import React, {useState, useRef} from "react";
import {Link, useHistory, useLocation} from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import Breadcrumb from 'layouts/main/Breadcrumb';
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import CommonUtil from 'utils/CommonUtil';
import StringUtil from "utils/StringUtil";
import DateUtil from "utils/DateUtil";
import codeDataStore from "common/codedata/store/CodeDataStore";
import UIUtils from "utils/UIUtils";

function ContentsContainer() {
    const location = useLocation();
    const receivedData = (location.state as any)?.data;
    const history = useHistory();

    const [totalRowCnt,setTotalRowCnt] = useState(0);
    const [showRowCnt,setShowRowCnt] = useState(20); //기본 row count

    let bankNm = useRef<string>("");
    let bankCd = useRef<string>("");

    let sheetCols = useRef<any>([
        {"Header": ["선택", {"Value": "", "Align": "Center","Icon": "Check","HeaderCheck": 1, "IconAlign": "Center"} ],"Type": "Bool", "Name": "sCheckBox","Align": "Center","RelWidth": 1,"CanEdit": "1", "BoolIcon": 4},
        {"Header": ["중소기업 지급 계좌 정보","수행기업"],"Type": "Text","Name": "SUPP_CORP_NM","RelWidth": 1.5,"Align": "Center" ,"CanEdit": 1},
        {"Header": ["중소기업 지급 계좌 정보","사업자등록번호"],"Type": "Text","Name": "SUPP_BIZ_NO","RelWidth": 2,"Align": "Center","CanEdit": 1},
        {"Header": ["중소기업 지급 계좌 정보","지원금액(원)"],"Type": "Int","Name": "PAY_AMT","RelWidth": 2,"Align": "Right","CanEdit": 1},
        {"Header": ["중소기업 지급 계좌 정보","대표자명"],"Type": "Text","Name": "SUPP_CEO_NM","RelWidth": 2,"Align": "Center","CanEdit": 1},
        {"Header": ["중소기업 지급 계좌 정보","특수관계인여부"],"Type": "Enum","Name": "SPC_RELATE_PERSON_YN","Align": "Center","CanEdit": 1,"Enum": "|예|아니오","EnumKeys": "|Y|N"},
        {"Header": ["중소기업 지급 계좌 정보","지급은행"],"Type": "Enum","Name": "SUPP_ACC_BANK_CD","RelWidth": 1.5,"Align": "Center","CanEdit": 1,"Enum": bankNm,"EnumKeys": bankCd},
        {"Header": ["중소기업 지급 계좌 정보","지급계좌"],"Type": "Text","Name": "SUPP_ACC_NO","RelWidth":1.5,"Align": "Center","CanEdit": 1},
        {"Header": ["중소기업 지급 계좌 정보","예금주"],"Type": "Text","Name": "SUPP_ACC_HOLDER","RelWidth": 1.5,"Align": "Center","CanEdit": 1},
        {"Header": ["중소기업 지급 계좌 정보","부가세 포함 여부"],"Type": "Enum","Name": "VAT_YN","RelWidth": 1.5,"Align": "Center","CanEdit": 1, "Enum": "|예|아니오","EnumKeys": "|Y|N"},
        {"Header": ["조회결과","수취인"],"Type": "Text","Name": "FIND_REF_NM","RelWidth": 1.5,"Align": "Center","CanEdit": 1},
    ]);

//                                                             지원기업            사업자등록번호     지원금액        대표자명           특수관계인여부              지급은행                지급계좌            예금주                수취인                                       유형코드
    const [suppCorpList, setSuppCorpList] = useState<any[]>([{ SUPP_CORP_NM : '', SUPP_BIZ_NO : '', PAY_AMT : '', SUPP_CEO_NM : '', SPC_RELATE_PERSON_YN : '', SUPP_ACC_BANK_CD : '', SUPP_ACC_NO : '', SUPP_ACC_HOLDER : '', FIND_REF_NM: '', num : 0 , checked : false, SUPP_TP_CD: '', VAT_YN: '' }]);
    const [suppNextNum,setSuppNextNum] = useState(1);
    const [perfCorpList, setPerfCorpList] = useState<any[]>([{ SUPP_CORP_NM : '', SUPP_BIZ_NO : '', PAY_AMT : '', SUPP_CEO_NM : '', SPC_RELATE_PERSON_YN : '', SUPP_ACC_BANK_CD : '', SUPP_ACC_NO : '', SUPP_ACC_HOLDER : '', FIND_REF_NM: '', num : 0 , checked : false, SUPP_TP_CD: '', VAT_YN: '' }]);
    const [perfNextNum,setPerfNextNum] = useState(1);

    var suppCorpItems: { SUPP_CORP_NM:string, SUPP_BIZ_NO:string, PAY_AMT:number, SUPP_CEO_NM:string, SPC_RELATE_PERSON_YN:string, SUPP_ACC_BANK_CD:string, SUPP_ACC_NO:string, SUPP_ACC_HOLDER:string, FIND_REF_NM:string, SUPP_TP_CD:string; }[] = [];
    // @ts-ignore
    var suppCorpItem: { SUPP_CORP_NM:string, SUPP_BIZ_NO:string, PAY_AMT:number, SUPP_CEO_NM:string, SPC_RELATE_PERSON_YN:string, SUPP_ACC_BANK_CD:string, SUPP_ACC_NO:string, SUPP_ACC_HOLDER:string, FIND_REF_NM:string, SUPP_TP_CD:string; } = {};
    const [suppCorpTmp,setSuppCorpTmp] = useState([]);

    const [suppCorpEa, setSuppCorpEa] = useState(0);    // 지원기업 수
    const [suppCorpAmt, setSuppCorpAmt] = useState(0);  // 지원기업 지원금

    const [perfCorpCnt, setPerfCorpCnt] = useState(0);  // 수행기업 수
    const [perfCorpAmt, setPerfCorpAmt] = useState(0);  // 수행기업 지원금
    const [reqAmt, setReqAmt] = useState(0);

    var bankNmTmp = "";
    var bankCdTmp = "";

    // receiveData
    const [tskReqNo, setTskReqNO] = useState('');
    const [tskReqModiSeq, setTskReqModiSeq] = useState('');
    const [perfCnt, setPerfCnt] = useState(0);      // 과제 신청 시 수행기관 입력 값(중요)

    //초기 데이터 설정
    let totalCnt:number = 0;
    let SheetData_supp = {};
    let SheetData_perf = {};

    //====== 그리드 공통 부 START
    var ib = ib||{};
    ib = {
        //시트 초기화 구문
        'init':{
            "Cfg": {
                "SearchMode": 1,
                "PageLength": 100,
                "AutoRowHeight": 1,
                "InfoRowConfig": "0",
                "Alternate":"0",
                "HeaderMerge": 6,
                "HeaderCheck": 1,
                "HeaderCheckMode": 1,
                "CanSort": 0,                 // 소팅옵션 off
                "ShowFilter": 1,             // 필터행 표시
                "dataMerge":1,
                "Height": "auto",
                "MenuMaxHeight": 300        // Enum 콤보박스 사이즈 조절
            },
            "Cols": [
                        {"Header": ["선택", {"Value": "", "Align": "Center","Icon": "Check","HeaderCheck": 1, "IconAlign": "Center"} ],"Type": "Bool", "Name": "sCheckBox","Align": "Center","RelWidth": 1,"CanEdit": "1", "BoolIcon": 4},
                        {"Header": ["중소기업 지급 계좌 정보","지원기업"],"Type": "Text","Name": "SUPP_CORP_NM","RelWidth": 1.5,"Align": "Center" ,"CanEdit": 1},
                        {"Header": ["중소기업 지급 계좌 정보","사업자등록번호"],"Type": "Text","Name": "SUPP_BIZ_NO","RelWidth": 2,"Align": "Center","CanEdit": 1},
                        {"Header": ["중소기업 지급 계좌 정보","지원금액(원)"],"Type": "Int","Name": "PAY_AMT","RelWidth": 2,"Align": "Right","CanEdit": 1},
                    ],
        },
        //시트 이벤트
        'event':{
            onRenderFirstFinish:function (evtParam) {
                //헤더행과 필터행 강제 머지

                //지원기업 헤더행 머지
                //@ts-ignore
                sheet.setMergeRange( sheet.getRowById("HR1"), "sCheckBox", sheet.getRowById("Filter"), "sCheckBox");
                //@ts-ignore
                sheet.setMergeRange( sheet.getRowById("HR1"), "PAY_AMT", sheet.getRowById("Filter"), "PAY_AMT");

            },
            //시트 클릭시 이벤트 처리
            onAfterClick:function(evtParam){


            },
            //시트가 렌더링된 후 발생되는 이벤트입니다. 발생시점은 아래와 같은 부분에서 발생합니다.
            onRenderFinish  :function(evtParam){

                //렌더 종료 후 1페이지일때 보이는행 제외 visible 0 처리
                var sheet = evtParam.sheet;
                var page = sheet.getPageIndex(sheet.getFocusedPage()) + 1;
                if(page === 1 && sheet.getShownRows().length != 0){
                    sheet.getDataRows().filter(x => !sheet.getShownRows().includes(x)).map(e => {
                        e.Visible = 0;
                        return e;
                    });
                }

            },
            onBeforeDataLoad:function (evtParam) {
                // 조회 후 로딩 전 발생 이벤트
                var d = evtParam.data;
                var _data;

                // 서버에서 가져온 데이터를 "데이터" 텝에 넣어준다.
                if (d.length > 20) { // 최대 20개 행만 텝에 넣어 주자(많아지면 화면이 엄청 느려질 수 있음)
                _data = JSON.stringify(d.slice(0, 20), null, 2);
                _data += _data.substring(0, _data.length - 1) + '...\n]';
                } else {
                _data = JSON.stringify(d, null, 2);
                }

            },
            onAfterGotoPage:function (evtParam) {

                var sheet = evtParam.sheet;
                var page = sheet.getPageIndex(sheet.getFocusedPage()) + 1;
                //@ts-ignore
                if (currentPage != -1 && currentPage != page) {
                  makePageIndex(page);
                }

                sheet.getDataRows().map(e => {
                    e.Visible = 1;
                    return e;
                })

                //현재 화면이 보이는 row가 0이 아닐때만
                if(sheet.getShownRows().length != 0){
                    //화면에 보이는 row 제외 Visible 0 처리
                    sheet.getDataRows().filter(x => !sheet.getShownRows().includes(x)).map(e => {
                        e.Visible = 0;
                        return e;
                    });
                }

                //@ts-ignore
                sheet.rerender(1); //최종 수정된 내용을 화면에 반영한다.

            },
            onAfterChange : function(evtParam) {

                //@ts-ignore
                var rows = sheet.getDataRows();
                var sum = 0;
                for(var i=0; i<rows.length; i++){
                    sum += rows[i]["PAY_AMT"];
                }
                setSuppCorpAmt(sum);
             	evtParam.sheet.setValue({row:evtParam.row, col:"FIND_REF_NM", val:"", render:1});
            },
            onImportFinish:function(evtParam){          // 엑셀 임포트 이벤트
                setSuppCorpEa(evtParam.data.length);

                //@ts-ignore
                let rows = sheet.getDataRows();
                let sum = 0;
                for(var i=0; i<rows.length; i++){
                    sum += rows[i]["PAY_AMT"];
                }
                setSuppCorpAmt(sum);

                //@ts-ignore
                sheet.rerender(1); //최종 수정된 내용을 화면에 반영한다.
            }
        },
        //시트객체 생성
        'create':function () {
            let options = this.init;
            //@ts-ignore
            options.Events = this.event;
            //@ts-ignore
            IBSheet.create({
                id: 'sheet', // 생성할 시트의 id
                el: 'suppCorpList', // 시트를 생성할 Dom 객체 및 id
                options: options, // 생성될 시트의 속성
                data: SheetData_supp // 생성될 시트의 정적데이터
            });

            // global 변수 선언
            //@ts-ignore
            window.currentPage = -1;
        },
        //엑셀 다운로드
        'exportData':function () {
        },
    }


    var ib_modal = ib_modal||{};
    ib_modal = {
        //시트 초기화 구문
        'init':{
                "Cfg": {
                    "SearchMode": 1,
                    "PageLength": 100,
                    "AutoRowHeight": 1,
                    "InfoRowConfig": "0",
                    "Alternate":"0",
                    "HeaderMerge": 6,
                    "HeaderCheck": 1,
                    "HeaderCheckMode": 1,
                    "CanSort": 0,                 // 소팅옵션 off
                    "ShowFilter": 1,             // 필터행 표시
                    "dataMerge":1,
                    "Height": "auto",
                    "MenuMaxHeight": 300        // Enum 콤보박스 사이즈 조절
                },
                "Cols": [
                    {"Header": ["선택", {"Value": "", "Align": "Center","Icon": "Check","HeaderCheck": 1, "IconAlign": "Center"} ],"Type": "Bool", "Name": "sCheckBox","Align": "Center","RelWidth": 1,"CanEdit": "1", "BoolIcon": 4},
                    {"Header": ["중소기업 지급 계좌 정보","수행기업"],"Type": "Text","Name": "SUPP_CORP_NM","RelWidth": 1.5,"Align": "Center" ,"CanEdit": 1},
                    {"Header": ["중소기업 지급 계좌 정보","사업자등록번호"],"Type": "Text","Name": "SUPP_BIZ_NO","RelWidth": 2,"Align": "Center","CanEdit": 1},
                    {"Header": ["중소기업 지급 계좌 정보","지원금액(원)"],"Type": "Int","Name": "PAY_AMT","RelWidth": 2,"Align": "Right","CanEdit": 1},
                    {"Header": ["중소기업 지급 계좌 정보","대표자명"],"Type": "Text","Name": "SUPP_CEO_NM","RelWidth": 2,"Align": "Center","CanEdit": 1},
                    {"Header": ["중소기업 지급 계좌 정보","특수관계인여부"],"Type": "Enum","Name": "SPC_RELATE_PERSON_YN","Align": "Center","CanEdit": 1,"Enum": "|예|아니오","EnumKeys": "|Y|N"},
                    {"Header": ["중소기업 지급 계좌 정보","지급은행"],"Type": "Enum","Name": "SUPP_ACC_BANK_CD","RelWidth": 1.5,"Align": "Center","CanEdit": 1,"Enum": bankNm,"EnumKeys": bankCd},
                    {"Header": ["중소기업 지급 계좌 정보","지급계좌"],"Type": "Text","Name": "SUPP_ACC_NO","RelWidth":1.5,"Align": "Center","CanEdit": 1},
                    {"Header": ["중소기업 지급 계좌 정보","예금주"],"Type": "Text","Name": "SUPP_ACC_HOLDER","RelWidth": 1.5,"Align": "Center","CanEdit": 1},
                    {"Header": ["중소기업 지급 계좌 정보","부가세 포함 여부"],"Type": "Enum","Name": "VAT_YN","RelWidth": 1.5,"Align": "Center","CanEdit": 1, "Enum": "|예|아니오","EnumKeys": "|Y|N"},
                    {"Header": ["조회결과","수취인"],"Type": "Text","Name": "FIND_REF_NM","RelWidth": 1.5,"Align": "Center","CanEdit": 1},
                ],
        },
        //시트 이벤트
        'event':{
            onRenderFirstFinish:function (evtParam) {
                //헤더행과 필터행 강제 머지
                //수행기업 헤더행 머지
                //@ts-ignore
                sheet2.setMergeRange( sheet2.getRowById("HR1"), "sCheckBox", sheet2.getRowById("Filter"), "sCheckBox");
                //@ts-ignore
                sheet2.setMergeRange( sheet2.getRowById("HR1"), "PAY_AMT", sheet2.getRowById("Filter"), "PAY_AMT");
                //@ts-ignore
                sheet2.setMergeRange( sheet2.getRowById("HR1"), "SUPP_CEO_NM", sheet2.getRowById("Filter"), "SUPP_CEO_NM");
                //@ts-ignore
                sheet2.setMergeRange( sheet2.getRowById("HR1"), "SPC_RELATE_PERSON_YN", sheet2.getRowById("Filter"), "SPC_RELATE_PERSON_YN");
                //@ts-ignore
                sheet2.setMergeRange( sheet2.getRowById("HR1"), "SUPP_ACC_BANK_CD", sheet2.getRowById("Filter"), "SUPP_ACC_BANK_CD");
                //@ts-ignore
                sheet2.setMergeRange( sheet2.getRowById("HR1"), "SUPP_ACC_NO", sheet2.getRowById("Filter"), "SUPP_ACC_NO");
                //@ts-ignore
                sheet2.setMergeRange( sheet2.getRowById("HR1"), "SUPP_ACC_HOLDER", sheet2.getRowById("Filter"), "SUPP_ACC_HOLDER");
                //@ts-ignore
                sheet2.setMergeRange( sheet2.getRowById("HR1"), "VAT_YN", sheet2.getRowById("Filter"), "VAT_YN");
                //@ts-ignore
                sheet2.setMergeRange( sheet2.getRowById("HR1"), "FIND_REF_NM", sheet2.getRowById("Filter"), "FIND_REF_NM");

            },
            //시트 클릭시 이벤트 처리
            onAfterClick:function(evtParam){
                var sheet = evtParam.sheet;

                // 수행 금액 합계
                // @ts-ignore
                var rows2 = sheet2.getDataRows();
                var sum2 = 0;
                for(var i=0; i<rows2.length; i++){
                    sum2 += rows2[i]["PAY_AMT"];
                }
                setPerfCorpAmt(sum2);

            },
            //시트가 렌더링된 후 발생되는 이벤트입니다. 발생시점은 아래와 같은 부분에서 발생합니다.
            onRenderFinish  :function(evtParam){
                //렌더 종료 후 1페이지일때 보이는행 제외 visible 0 처리
                var sheet = evtParam.sheet;
                var page = sheet.getPageIndex(sheet.getFocusedPage()) + 1;
                if(page === 1 && sheet.getShownRows().length != 0){
                    sheet.getDataRows().filter(x => !sheet.getShownRows().includes(x)).map(e => {
                        e.Visible = 0;
                        return e;
                    });
                }

            },
            onBeforeDataLoad:function (evtParam) {
                // 조회 후 로딩 전 발생 이벤트
                var d = evtParam.data;
                var _data;

                // 서버에서 가져온 데이터를 "데이터" 텝에 넣어준다.
                if (d.length > 20) { // 최대 20개 행만 텝에 넣어 주자(많아지면 화면이 엄청 느려질 수 있음)
                    _data = JSON.stringify(d.slice(0, 20), null, 2);
                    _data += _data.substring(0, _data.length - 1) + '...\n]';
                } else {
                    _data = JSON.stringify(d, null, 2);
                }

            },
            onAfterGotoPage:function (evtParam) {

                var sheet = evtParam.sheet;
                var page = sheet.getPageIndex(sheet.getFocusedPage()) + 1;
                //@ts-ignore
                if (currentPage != -1 && currentPage != page) {
                    makePageIndex(page);
                }

                sheet.getDataRows().map(e => {
                    e.Visible = 1;
                    return e;
                })

                //현재 화면이 보이는 row가 0이 아닐때만
                if(sheet.getShownRows().length != 0){
                    //화면에 보이는 row 제외 Visible 0 처리
                    sheet.getDataRows().filter(x => !sheet.getShownRows().includes(x)).map(e => {
                        e.Visible = 0;
                        return e;
                    });
                }

                //@ts-ignore
                sheet.rerender(1); //최종 수정된 내용을 화면에 반영한다.

            },
            onAfterChange : function(evtParam) {
                console.log(evtParam);
                //@ts-ignore
                var rows2 = sheet2.getDataRows();
                var sum2 = 0;
                for(var i=0; i<rows2.length; i++){
                    sum2 += rows2[i]["PAY_AMT"];
                }
                setPerfCorpAmt(sum2);
            },
            onImportFinish:function(evtParam){          // 엑셀 임포트 이벤트
                setPerfCnt(evtParam.data.length);

                //@ts-ignore
                let rows2 = sheet2.getDataRows();
                var sum2 = 0;
                for(var i=0; i<rows2.length; i++){
                    sum2 += rows2[i]["PAY_AMT"];
                }
                setPerfCorpAmt(sum2);

                //@ts-ignore
                sheet2.rerender(1); //최종 수정된 내용을 화면에 반영한다.
            }
        },
        //시트객체 생성
        'create':function () {
            let options2 = this.init;
            options2.Cols = sheetCols.current;
            //@ts-ignore
            options2.Events = this.event;

            //@ts-ignore
            IBSheet.create({
                id: 'sheet2', // 생성할 시트의 id
                el: 'perfCorpList', // 시트를 생성할 Dom 객체 및 id
                options: options2, // 생성될 시트의 속성
                data: SheetData_perf // 생성될 시트의 정적데이터
            });

            // global 변수 선언
            //@ts-ignore
            window.currentPage = -1;
        },
        //엑셀 다운로드
        'exportData':function () {
        },
    }

    //====== 그리드 공통 부  END

    //페이지 건수별로 보기
    const handleSelect = (e) => {
      if(e.target.name === 'showRowCnt'){
          setShowRowCnt(e.target.value);
          // @ts-ignore
          IBSheet.disposeAll(true);
          ib.init.Cfg.PageLength = e.target.value;
          ib.create();
          ib_modal.create();

       }
    };

    //====== 그리드 데이터 가지고 오기  START
    async function initCall() {
        let param = {};

        param = {
            "PAY_REQ_NO": tskReqNo,
//                 "PAY_REQ_NO": 'Y220001783', // tsk_req_no / 임시 : Y220001783 , Y220000086
            "SUPP_TP_CD": 'S'
        };

        //파라미터 전송
        const response:any = await CommonUtil.execute({
            url:'usr_2116',
            data: param
        })

        //전체데이터
        let result = response.REC;

        if(result != null){
            //전체ROW개수
            totalCnt = Object.keys(result).length;
            setTotalRowCnt(Object.keys(result).length);
        }

        //데이터 처리
        ib.data = result;
        // @ts-ignore
        sheet.loadSearchData(result);  //data 로딩 처리
        // @ts-ignore
        sheet2.loadSearchData(result);  //data 로딩 처리
        // @ts-ignore
        sheet.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
        // @ts-ignore
        sheet2.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함

        // @ts-ignore
        makePageIndex(sheet.getPageIndex( sheet.getFocusedPage()) + 1); // 페이지 초기화
        // @ts-ignore
        makePageIndex(sheet2.getPageIndex( sheet2.getFocusedPage()) + 1); // 페이지 초기화

    }

    //====== 그리드 데이터 가지고 오기  END

    //====== 그리드 페이징 처리
    // @ts-ignore
    const makePageIndex = function (tp:number) {
      try {
        if (tp == null) {
            //@ts-ignore
            currentPage = -1;
            return;
        }

        // @ts-ignore
        if (document.getElementById('pageNavi').firstChild) {
          // @ts-ignore
          document.getElementById('pageNavi').removeChild(document.getElementById('pageNavi').firstChild);
        }

        // @ts-ignore
        currentPage = tp;
        // @ts-ignore
        let sr = totalCnt // 전체 조회 건수
        // @ts-ignore
        let page = showRowCnt; // 페이지당 레코드 수
        let thispage = tp; // 현재 페이지
        let pagecnt = 5; // 한번에 표시할 페이지 개수
        let lastpage = Math.ceil(sr / page); // 마지막 페이지 인덱스
        let li, tt, a;
        let ul = document.createElement('DIV');
        // @ts-ignore
        ul.style.textAlign = 'center';

        let k = 1;

        if (thispage !== 1) {
          let ul_sub = document.createElement('DIV');
          ul_sub.className ="group";
          li = document.createElement('Button');
          li.className = 'item first';
          a = document.createElement('a');
          a.style.cursor = 'pointer';
          tt = document.createTextNode('<<');
          addEventHandler(li, 'click', pageMove, 1);
          a.appendChild(tt);
          li.appendChild(a);
          ul_sub.appendChild(li)
          ul.appendChild(ul_sub);

          li = document.createElement('Button');
          li.className = 'item prev';
          a = document.createElement('a');
          a.style.cursor = 'pointer';
          addEventHandler(li, 'click', pageMove, tp - 1);
          tt = document.createTextNode('<');
          a.appendChild(tt);
          li.appendChild(a);
          ul_sub.appendChild(li)
          ul.appendChild(ul_sub);
        }

        sr = (Math.ceil(tp / pagecnt) * pagecnt) - (pagecnt - 1);
        let ul_sub2 = document.createElement('DIV');
        ul_sub2.className ="group";
        for (let i = sr; i < (sr + pagecnt); i++) {
          if (i <= lastpage) {
            li = document.createElement('Button');
            li.className ="item";
            a = document.createElement('a');
            a.style.cursor = 'pointer';
            tt = document.createTextNode(String(i));
            addEventHandler(li, 'click', pageMove, i);
            if (i === tp) {
              li.className ="item active";
            }
            a.appendChild(tt);
            li.appendChild(a);
            ul_sub2.appendChild(li);
            ul.appendChild(ul_sub2);
          }
        }

        if (thispage < lastpage) {
          let ul_sub3 = document.createElement('DIV');
          ul_sub3.className ="group";
          a = document.createElement('a');
          a.style.cursor = 'pointer';
          li = document.createElement('Button');
          li.className = 'item next';
          tt = document.createTextNode('>');
          addEventHandler(li, 'click', pageMove, tp + 1);
          a.appendChild(tt);
          li.appendChild(a);
          ul_sub3.appendChild(li);
          ul.appendChild(ul_sub3);

          li = document.createElement('Button');
          li.className = 'item last';
          tt = document.createTextNode('>>');
          a = document.createElement('a');
          a.style.cursor = 'pointer';
          addEventHandler(li, 'click', pageMove, lastpage);
          a.appendChild(tt);
          li.appendChild(a);
          ul_sub3.appendChild(li);
          ul.appendChild(ul_sub3);
        }

        ul.className = 'pg';
        // @ts-ignore
        document.getElementById('pageNavi').appendChild(ul);
      } catch (ex) {
        // @ts-ignore
        console.log(ex.message);
      }
    }

    //페이지 이동
    // @ts-ignore
    const pageMove = function (cPage:number) {
      // @ts-ignore
      sheet.goToPageByIndex(cPage);

    }

    //페이지 이동 이벤트 핸들러
    // @ts-ignore
    const addEventHandler = function (obj, evtName, func, param) {
      if (obj.addEventListener) { // all browsers except IE before version 9
        obj.addEventListener(evtName, function () { func(param); }, false);
      } else if (obj.attachEvent) { // IE before version 9
        obj.attachEvent('on' + evtName, function () { func(param); });
      }
    }

    //행 추가
    async function addRow (type){
        if(type == 'supp'){
            //@ts-ignore
            sheet.addRow({ visible: 1 });

            //전체 row visible 1 처리
            //@ts-ignore
            sheet.getDataRows().map(e => {
                e.Visible = 1;
                return e;
            })

            //화면에 보이는 row 제외 Visible 0 처리
            //@ts-ignore
            if(sheet.getShownRows().length != 0){
                //@ts-ignore
                sheet.getDataRows().filter(x => !sheet.getShownRows().includes(x)).map(e => {
                    e.Visible = 0;
                    return e;
                });
            }

            const suppNextList = suppCorpList.concat({
                SUPP_CORP_NM : '', SUPP_BIZ_NO : '', PAY_AMT : '', SUPP_CEO_NM : '', SPC_RELATE_PERSON_YN : '', SUPP_ACC_BANK_CD : '', SUPP_ACC_NO : '', FIND_REF_NM: '', num : 0 , checked : false
            });

            setSuppNextNum(suppNextNum + 1);
            setSuppCorpList(suppNextList);
            setSuppCorpEa(suppCorpEa + 1);

            //@ts-ignore
            sheet.rerender(1); //최종 수정된 내용을 화면에 반영한다.

        } else {
            //@ts-ignore
            sheet2.addRow({ visible: 1 });

            //전체 row visible 1 처리
            //@ts-ignore
            sheet2.getDataRows().map(e => {
                e.Visible = 1;
                return e;
            })

            //화면에 보이는 row 제외 Visible 0 처리
            //@ts-ignore
            if(sheet2.getShownRows().length != 0){
                //@ts-ignore
                sheet2.getDataRows().filter(x => !sheet2.getShownRows().includes(x)).map(e => {
                    e.Visible = 0;
                    return e;
                });
            }

            const perfNextList = suppCorpList.concat({
                SUPP_CORP_NM : '', SUPP_BIZ_NO : '', PAY_AMT : '', SUPP_CEO_NM : '', SPC_RELATE_PERSON_YN : '', SUPP_ACC_BANK_CD : '', SUPP_ACC_NO : '', FIND_REF_NM: '', num : 0 , checked : false
            });

            setPerfNextNum(perfNextNum + 1);
            setPerfCorpList(perfNextList);
            setPerfCorpCnt(perfCorpCnt + 1);

            //@ts-ignore
            sheet2.rerender(1); //최종 수정된 내용을 화면에 반영한다.

        }
    }

    // 행 삭제
    async function delRow (type){
        if(type == 'supp'){
            //@ts-ignore
            var fRows;
            //@ts-ignore
            fRows = sheet.getDataRows().filter(x => x.sCheckBox === 1);

            if(fRows <= 0) {
                UIUtils.alert('삭제할 행을 선택해 주세요.').then();
            }

            //@ts-ignore
            sheet.removeRows(fRows);
            //@ts-ignore
            sheet.rerender(1); //최종 수정된 내용을 화면에 반영한다.
            //@ts-ignore
            setSuppCorpEa(sheet.getShownRows().length);
        } else {
            //@ts-ignore
            var fRows;
            //@ts-ignore
            fRows = sheet2.getDataRows().filter(x => x.sCheckBox === 1);

            if(fRows <= 0) {
                UIUtils.alert('삭제할 행을 선택해 주세요.').then();
            }

            //@ts-ignore
            sheet2.removeRows(fRows);
            //@ts-ignore
            sheet2.rerender(1); //최종 수정된 내용을 화면에 반영한다.
            //@ts-ignore
            setPerfCorpCnt(sheet2.getShownRows().length)
        }

    }


    // 예금주 조회
    async function checkInq() {

        // UIUtils.alert('해당기능은 사용할 수 없습니다.').then();
        // return;

        // @ts-ignore
        let rows = sheet2.getDataRows();

        // 수행기업 입력사항 체크
        for(var i=0; i<rows.length; i++) {
            if(rows[i]["SUPP_CORP_NM"] == "" || rows[i]["SUPP_BIZ_NO"] == "" || rows[i]["PAY_AMT"] == "" ||
                rows[i]["SUPP_CEO_NM"] == "" || rows[i]["SPC_RELATE_PERSON_YN"] == "" || rows[i]["SUPP_ACC_BANK_CD"] == "" ||
                rows[i]["SUPP_ACC_NO"] == "" || rows[i]["SUPP_ACC_HOLDER"] == "" || rows[i]["VAT_YN"] == ""
            ){
                UIUtils.alert('기금지원내역과 수행기업 지급 계좌정보를 입력해주세요').then();
                return;
            }
        }

        // 지원기업 입력사항 체크
        for(var i=0; i<rows.length; i++) {
            if(rows[i]["SUPP_CORP_NM"] == "" || rows[i]["SUPP_BIZ_NO"] == "" || rows[i]["PAY_AMT"] == ""){
                UIUtils.alert('기금지원내역과 지원기업 지급 계좌정보를 입력해주세요').then();
                return;
            }
        }

        let corpItems: { SUPP_CORP_NM:string, SUPP_BIZ_NO:string, PAY_AMT:number, SUPP_CEO_NM:string, SPC_RELATE_PERSON_YN:string, SUPP_ACC_BANK_CD:string, SUPP_ACC_NO:string, SUPP_ACC_HOLDER:string, FIND_REF_NM:string, VAT_YN:string; }[] = [];
        // @ts-ignore
        let corpItem: { SUPP_CORP_NM:string, SUPP_BIZ_NO:string, PAY_AMT:number, SUPP_CEO_NM:string, SPC_RELATE_PERSON_YN:string, SUPP_ACC_BANK_CD:string, SUPP_ACC_NO:string, SUPP_ACC_HOLDER:string, FIND_REF_NM:string, VAT_YN:string; } = {};

        // 입력값 확인
        for (var i = 0; i < rows.length; i++) {

            let suppBizNo = rows[i]["SUPP_BIZ_NO"].toString().replaceAll('-','');
            let suppAccNo = rows[i]["SUPP_ACC_NO"].toString().replaceAll('-','');

            // @ts-ignore
            corpItem = {
                SUPP_CORP_NM: rows[i]["SUPP_CORP_NM"],
                SUPP_BIZ_NO: suppBizNo,
                PAY_AMT: rows[i]["PAY_AMT"],
                SUPP_CEO_NM: rows[i]["SUPP_CEO_NM"],
                SPC_RELATE_PERSON_YN: rows[i]["SPC_RELATE_PERSON_YN"],
                SUPP_ACC_BANK_CD: rows[i]["SUPP_ACC_BANK_CD"],
                SUPP_ACC_NO: suppAccNo,
                SUPP_ACC_HOLDER: rows[i]["SUPP_ACC_HOLDER"],
                VAT_YN: rows[i]["VAT_YN"]
            }
            corpItems.push(corpItem);
        }

        // *** 예금주 조회 로직 추후 추가 ***

        let param = { LIST: corpItems };

        console.log(param);

        //파라미터 전송
        const response:any = await CommonUtil.execute({
            url:'usr_2117',
            data: param
        }).then((response:any) => {
            console.log(response.REC);
            SheetData_perf = response.REC;
            // @ts-ignore
            sheet2.loadSearchData(SheetData_perf);
        }).catch((error) => {
            CommonUtil.showAxiosError(error);
            return;
        });


    }

    // 지원/수행 기업 저장
    async function saveCorp() {

        // @ts-ignore
        let rows = sheet.getDataRows();

        // 지원기업 필수입력체크
        for(var i=0; i<rows.length; i++) {
            if(rows[i]["SUPP_CORP_NM"] == "" || rows[i]["SUPP_BIZ_NO"] == "" || rows[i]["PAY_AMT"] == ""){
                UIUtils.alert('기금지원내역과 중소기업 지급 계좌정보를 입력해주세요').then();
                return;
            }
        }

        // 지원기업 중복 체크
        let arrBizNos: string[] = [];
        let bizNoDplctMsg = "";
        for(var i=0; i<rows.length; i++) {
            arrBizNos.push(StringUtil.replaceAll(rows[i]["SUPP_BIZ_NO"], "-", ""));
        }
        const rstbizNos: any = arrBizNos.reduce((accu, curr) => {
          accu.set(curr, (accu.get(curr) || 0) + 1);
          return accu;
        }, new Map());
        for (let [key, value] of rstbizNos.entries()) {
          if (value > 1) {
            bizNoDplctMsg += "사업자등록번호: " + key;
            bizNoDplctMsg += " (" + value + "건)\n";
          }
        }
        // if (bizNoDplctMsg !== "") {
        //     UIUtils.alert('중복되는 지원기업 사업자등록번호가 존재합니다.').then();
        //   return;
        // }

        // 지원기업 중복 체크

        // @ts-ignore
        let rows2 = sheet2.getDataRows();

        // 필수값 체크   *** 예금주조회로 이동 해야함***
        for(var i=0; i<rows2.length; i++) {
            if(rows2[i]["SUPP_CORP_NM"] == "" || rows2[i]["SUPP_BIZ_NO"] == "" || rows2[i]["PAY_AMT"] == "" ||
                rows2[i]["SUPP_CEO_NM"] == "" || rows2[i]["SPC_RELATE_PERSON_YN"] == "" || rows2[i]["SUPP_ACC_BANK_CD"] == "" ||
                rows2[i]["SUPP_ACC_NO"] == "" || rows2[i]["SUPP_ACC_HOLDER"] == "" || rows2[i]["VAT_YN"] == ""
            ){
                UIUtils.alert('기금지원내역과 수행기업 지급 계좌정보를 입력해주세요').then();
                return;
            } else if(rows[i]["FIND_REF_NM"] == undefined) {
                UIUtils.alert('예금주 조회 후 다음버튼을 선택해주세요.').then();
                return;
            } else if(rows[i]["FIND_REF_NM"] === "실패") {
                UIUtils.alert('예금주조회에서 실패한 계좌정보는 삭제 후 다시 시도해 주세요.').then();
                return;
            }
        }

        let arrPerfBizNos: string[] = [];
        let PerfbizNoDplctMsg = "";
        for(var i=0; i<rows2.length; i++) {
            arrPerfBizNos.push(StringUtil.replaceAll(rows2[i]["SUPP_BIZ_NO"], "-", ""));
        }
        const perfRstbizNos: any = arrPerfBizNos.reduce((accu, curr) => {
          accu.set(curr, (accu.get(curr) || 0) + 1);
          return accu;
        }, new Map());
        for (let [key, value] of perfRstbizNos.entries()) {
          if (value > 1) {
            PerfbizNoDplctMsg += "사업자등록번호: " + key;
            PerfbizNoDplctMsg += " (" + value + "건)\n";
          }
        }
        // if (PerfbizNoDplctMsg !== "") {
        //     UIUtils.alert('중복되는 수행기업 사업자등록번호가 존재합니다.').then();
        //   return;
        // }

         let suppAmtSum = 0;    // 지원기업 지원금액
         let perfAmtSum = 0;    // 수행기업 지원금액

        // 지원기업 목록
        let suppCorpItems: { SUPP_CORP_NM:string, SUPP_BIZ_NO:string, PAY_AMT:number, SUPP_CEO_NM:string, SPC_RELATE_PERSON_YN:string, SUPP_ACC_BANK_CD:string, SUPP_ACC_NO:string, SUPP_ACC_HOLDER:string, FIND_REF_NM:string, VAT_YN:string; }[] = [];
        // 수행기업 목록
        let perfCorpItems: { SUPP_CORP_NM:string, SUPP_BIZ_NO:string, PAY_AMT:number, SUPP_CEO_NM:string, SPC_RELATE_PERSON_YN:string, SUPP_ACC_BANK_CD:string, SUPP_ACC_NO:string, SUPP_ACC_HOLDER:string, FIND_REF_NM:string, VAT_YN:string; }[] = [];

        // @ts-ignore
        let suppCorpItem: { SUPP_CORP_NM:string, SUPP_BIZ_NO:string, PAY_AMT:number, SUPP_CEO_NM:string, SPC_RELATE_PERSON_YN:string, SUPP_ACC_BANK_CD:string, SUPP_ACC_NO:string, SUPP_ACC_HOLDER:string, FIND_REF_NM:string, VAT_YN:string; } = {};
        // @ts-ignore
        let perfCorpItem: { SUPP_CORP_NM:string, SUPP_BIZ_NO:string, PAY_AMT:number, SUPP_CEO_NM:string, SPC_RELATE_PERSON_YN:string, SUPP_ACC_BANK_CD:string, SUPP_ACC_NO:string, SUPP_ACC_HOLDER:string, FIND_REF_NM:string, VAT_YN:string; } = {};

        // 지원기업 목록 구성
        for(var i=0; i<rows.length; i++) {
            suppCorpItem = {
                SUPP_CORP_NM: rows[i]["SUPP_CORP_NM"],
                SUPP_BIZ_NO: rows[i]["SUPP_BIZ_NO"],
                PAY_AMT: rows[i]["PAY_AMT"],
                SUPP_CEO_NM: rows[i]["SUPP_CEO_NM"],
                SPC_RELATE_PERSON_YN: rows[i]["SPC_RELATE_PERSON_YN"],
                SUPP_ACC_BANK_CD: rows[i]["SUPP_ACC_BANK_CD"],
                SUPP_ACC_NO: rows[i]["SUPP_ACC_NO"],
                SUPP_ACC_HOLDER: rows[i]["SUPP_ACC_HOLDER"],
                FIND_REF_NM: rows[i]["FIND_REF_NM"],
                VAT_YN: rows[i]["VAT_YN"],
            }
            suppCorpItems.push(suppCorpItem);

            suppAmtSum += rows[i]["PAY_AMT"];
        }

        let suppCnt = rows.length;

        // 수행기업 목록 구성
        for(var i=0; i<rows2.length; i++) {
            perfCorpItem = {
                SUPP_CORP_NM: rows2[i]["SUPP_CORP_NM"],
                SUPP_BIZ_NO: rows2[i]["SUPP_BIZ_NO"],
                PAY_AMT: rows2[i]["PAY_AMT"],
                SUPP_CEO_NM: rows2[i]["SUPP_CEO_NM"],
                SPC_RELATE_PERSON_YN: rows2[i]["SPC_RELATE_PERSON_YN"],
                SUPP_ACC_BANK_CD: rows2[i]["SUPP_ACC_BANK_CD"],
                SUPP_ACC_NO: rows2[i]["SUPP_ACC_NO"],
                SUPP_ACC_HOLDER: rows2[i]["SUPP_ACC_HOLDER"],
                FIND_REF_NM: rows2[i]["FIND_REF_NM"],
                VAT_YN: rows2[i]["VAT_YN"],
            }
            perfCorpItems.push(perfCorpItem);

            perfAmtSum += rows2[i]["PAY_AMT"];
        }

        let perfCnt = rows2.length;

        setSuppCorpAmt(suppAmtSum);
        setSuppCorpEa(rows.length);
        setPerfCorpAmt(perfAmtSum);
        setPerfCorpCnt(rows2.length);

        let suppTotAmt = suppAmtSum;
        let suppTotCnt = rows.length;
        let perfTotAmt = perfAmtSum;
        let perfTotCnt = rows2.length;

        if(suppTotAmt !== perfTotAmt) {
            UIUtils.alert('지원금액합계와 지급금액합계금액을 동일하게 입력해 주세요.').then();
            return;
        }

        if(Number(reqAmt) < Number(suppAmtSum)){
            UIUtils.alert("잔여 과제신청 금액이 부족합니다. 신청 가능 금액 : " + StringUtil.formatNumber(Number(reqAmt)) + "원 입니다").then();
            return;
        }

        // if(Number(suppAmtSum) >0 ){
        //     if(Number(reqAmt) != Number(suppTotAmt)){
        //         UIUtils.alert("과제신청 금액과 지원금액 합계가 동일해야합니다.").then();
        //         return;
        //     }
        // }


        let dataToSend = { tskReqNo,        // 과제신청번호
                            tskReqModiSeq,   // 과제 차수
                            suppTotCnt,      // 지원기업 수
                            suppTotAmt,     // 지원기업 총지원금
                            suppCorpItems,   // 지원기업 목록
                            perfTotCnt,     // 수행기업 수
                            perfTotAmt,     // 수행기업 총 지원금
                            perfCorpItems,   // 수행기업 목록
                         };

        console.log(dataToSend);

        // 다른 페이지로 이동하면서 데이터 전달
        history.push({
            pathname: './usr_2119',
            state: { data: dataToSend }
        });

    }

    // 지원기업(수행기업있는) 양식 다운로드
    const subjTemplateDownload = () => {
        console.log("subjTemplateDownload");
        CommonUtil.downloadTemplateFile("suppListTemplate2.xlsx", "지원기업내역(양식).xlsx");
    };

    // 지원기업 양식 업로드
    const subjTemplateUpload = () => {
        //@ts-ignore
        sheet.loadExcel({ mode: 'HeaderSkip' });
    }

    // 수행기업 양식 다운로드
    const subjTemplateDownload2 = () => {
        console.log("subjTemplateDownload2");
        CommonUtil.downloadTemplateFile("perfListTemplate.xlsx", "수행기업내역(양식).xlsx");
    };

    // 지원기업 양식 업로드
    const subjTemplateUpload2 = () => {
        //@ts-ignore
        sheet2.loadExcel({ mode: 'HeaderSkip' });
    }


    // init
    React.useEffect(() => {

//         console.log(receivedData);
        if(receivedData != undefined){
            let reqNo = StringUtil.defaultString(receivedData?.tskReqNo);
            let reqSeq = StringUtil.defaultString(receivedData?.tskReqModiSeq);
            let reqAmtTmp = receivedData?.reqAmt;
            setTskReqNO(reqNo);
            setTskReqModiSeq(reqSeq);
            setReqAmt(reqAmtTmp);
            localStorage.setItem("tskReqNo", tskReqNo);
            localStorage.setItem("tskReqModiSeq", tskReqModiSeq);

        }

        //필요한 공통코드 로딩.
        codeDataStore.read("[BANK]",).then(() => {
            var codeData = codeDataStore.get("[BANK]");
            codeData = codeData.filter((v) => { return (v.code !== '019' && v.code !== '084' && v.code !== '080' && v.code !== '010') });
            for(var i=0; i<codeData.length; i++) {
                bankNmTmp += "|" + codeData[i].name;
                bankCdTmp += "|" + codeData[i].code;
            }

            bankNm.current = bankNmTmp;
            bankCd.current = bankCdTmp;


        }).then(() => {
            sheetCols.current = [
                            {"Header": ["선택", {"Value": "", "Align": "Center","Icon": "Check","HeaderCheck": 1, "IconAlign": "Center"} ],"Type": "Bool", "Name": "sCheckBox","Align": "Center","RelWidth": 1,"CanEdit": "1", "BoolIcon": 4},
                            {"Header": ["중소기업 지급 계좌 정보","수행기업"],"Type": "Text","Name": "SUPP_CORP_NM","RelWidth": 1.5,"Align": "Center" ,"CanEdit": 1},
                            {"Header": ["중소기업 지급 계좌 정보","사업자등록번호"],"Type": "Text","Name": "SUPP_BIZ_NO","RelWidth": 2,"Align": "Center","CanEdit": 1},
                            {"Header": ["중소기업 지급 계좌 정보","지원금액(원)"],"Type": "Int","Name": "PAY_AMT","RelWidth": 2,"Align": "Right","CanEdit": 1},
                            {"Header": ["중소기업 지급 계좌 정보","대표자명"],"Type": "Text","Name": "SUPP_CEO_NM","RelWidth": 2,"Align": "Center","CanEdit": 1},
                            {"Header": ["중소기업 지급 계좌 정보","특수관계인여부"],"Type": "Enum","Name": "SPC_RELATE_PERSON_YN","Align": "Center","CanEdit": 1,"Enum": "|예|아니오","EnumKeys": "|Y|N"},
                            {"Header": ["중소기업 지급 계좌 정보","지급은행"],"Type": "Enum","Name": "SUPP_ACC_BANK_CD","RelWidth": 1.5,"Align": "Center","CanEdit": 1,"Enum": bankNm.current,"EnumKeys": bankCd.current},
                            {"Header": ["중소기업 지급 계좌 정보","지급계좌"],"Type": "Text","Name": "SUPP_ACC_NO","RelWidth":1.5,"Align": "Center","CanEdit": 1},
                            {"Header": ["중소기업 지급 계좌 정보","예금주"],"Type": "Text","Name": "SUPP_ACC_HOLDER","RelWidth": 1.5,"Align": "Center","CanEdit": 1},
                            {"Header": ["중소기업 지급 계좌 정보","부가세 포함 여부"],"Type": "Enum","Name": "VAT_YN","RelWidth": 1.5,"Align": "Center","CanEdit": 1, "Enum": "|예|아니오","EnumKeys": "|Y|N"},
                            {"Header": ["조회결과","수취인"],"Type": "Text","Name": "FIND_REF_NM","RelWidth": 1.5,"Align": "Center","CanEdit": 0},
                        ]
            //ib시트 생성
            ib.create();
            ib_modal.create();

            // @ts-ignore
            sheet.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
            // @ts-ignore
            sheet2.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함

            // @ts-ignore
            sheet.loadSearchData(SheetData_supp);

            // @ts-ignore
            sheet2.loadSearchData(SheetData_perf);

            // @ts-ignore
            makePageIndex(sheet.getPageIndex( sheet.getFocusedPage()) + 1); // 페이지 초기화
            // @ts-ignore
            makePageIndex(sheet2.getPageIndex( sheet2.getFocusedPage()) + 1); // 페이지 초기화
        });

        return () => {
          // @ts-ignore
          IBSheet.disposeAll(true);
        }

    },[])

	return (
		<PageContainer >
			<LayoutAside />
			<div className='fww-con'>
				<Breadcrumb gnbIdx={2} lnbIdx={2}/>
				<main className="fww-main">
					<h1 className="tx tx-hd2">지급 등록</h1>

					<section className="fund-section">
                        <div className="hz-root hz-sb mb15">
                            <h3 className="section-title">지원 기업 정보 입력</h3>
                            <div className="hz-root hz-gap5">
                                <Button color='pri-o' size="sm" onClick={() => addRow('supp')}>행추가</Button>
                                <Button color='gray-o' size="sm" onClick={() => delRow('supp')}>행삭제</Button>
                                <Button color='pri-o' size="sm"  onClick={subjTemplateDownload}>지원기업목록 양식받기</Button>
                                <Button color='gray-o' size="sm" onClick={subjTemplateUpload}>지원기업목록 Upload</Button>
                            </div>
                        </div>
                        <div className="tb-total mb15">
                            <div className="tb-total-items">지원 금액 합계(원)</div>
                            <div className="tb-total-items">
                                <div className="fund-form-items tf-unit">
                                    <UIInput className={'tf tf-md ta-right'} value={StringUtil.formatNumber(Number(suppCorpAmt)) || "0"} placeholder={''}  readOnly={true}/>
                                    <span className="u">원</span>
                                </div>
                                <p className="tx-msg"><span className="fc-pri">({StringUtil.isNotEmpty(suppCorpAmt + "") ?
                                                                                StringUtil.numKorPattern(suppCorpAmt) + " 원" : "원"})</span></p>
                            </div>
                        </div>
                        <div className="tb-top">
                            <div>
                                <p className="tx fc-black">총 <em className="fw500">{suppCorpEa}</em>건</p>
                            </div>
                            {/*
                            <div className="hz-root hz-gap8">
                                <div className="sl sl-sm w120">
                                    <select name="suppCorpEa" id="suppCorpEa" className="" value={suppCorpEa} onChange={(handleSelect)}>
                                        <option value="20">20개씩보기</option>
                                        <option value="50">50개씩보기</option>
                                        <option value="100">100개씩보기</option>
                                        <option value="200">200개씩보기</option>
                                        <option value="500">500개씩보기</option>
                                        <option value="1000">1000개씩보기</option>
                                    </select>
                                </div>
                            </div>
                            */}
                        </div>
                        <div className="sheetDiv">
                            <div id='suppCorpList'>[D] IBSHEET 영역</div>

                            <div id="pageNavi" className="pg"></div>
                        </div>
                    </section>

					<section className="fund-section">
						<div className="hz-root hz-sb mb15">
							<h3 className="section-title">수행 기업 정보 입력</h3>
							<div className="hz-root hz-gap5">
								<Button color='pri-o' size="sm" onClick={() => addRow('perf')}>행추가</Button>
                                <Button color='gray-o' size="sm" onClick={() => delRow('perf')}>행삭제</Button>
								<Button color='pri-o' size="sm" onClick={subjTemplateDownload2}>수행기업목록 양식받기</Button>
								<Button color='gray-o' size="sm" onClick={subjTemplateUpload2}>수행기업목록 Upload</Button>
							</div>
						</div>
						<div className="tb-total mb15">
							<div className="tb-total-items">지원 금액 합계(원)</div>
                        <div className="tb-total-items">
                            <div className="fund-form-items tf-unit">
                                <UIInput className={'tf tf-md ta-right'} value={StringUtil.formatNumber(Number(perfCorpAmt)) || "0"} placeholder={''}  readOnly={true}/>
                                <span className="u">원</span>
                            </div>
                            <p className="tx-msg"><span className="fc-pri">({StringUtil.isNotEmpty(perfCorpAmt + "") ?
                                                                             StringUtil.numKorPattern(perfCorpAmt) + " 원" : "원"})</span></p>
                        </div>
						</div>
						<div className="tb-top">
							<div>
								<p className="tx fc-black">총 <em className="fw500">{perfCorpCnt}</em>건</p>
							</div>
                            {/*
							<div className="hz-root hz-gap8">
								<div className="sl sl-sm w120">
									<select name="perfCorpCnt" id="perfCorpCnt" className="" value={perfCorpCnt}  onChange={(handleSelect)}>
										<option value="20">20개씩보기</option>
                                        <option value="50">50개씩보기</option>
                                        <option value="100">100개씩보기</option>
                                        <option value="200">200개씩보기</option>
                                        <option value="500">500개씩보기</option>
                                        <option value="1000">1000개씩보기</option>
									</select>
								</div>
							</div>
                            */}
						</div>
						<div className="ibsheet">

							<div id='perfCorpList'>[D] IBSHEET 영역</div>

							<div id="pageNavi" className="pg"></div>
						</div>
					</section>
					<div className="hz-root hz-right hz-gap10 mt30">
						<Button color="pri" size="md" onClick={() => checkInq()}>예금주조회</Button>
						<Button color="gray-o" size="md" href="/main/usr_2100/usr_2114">취소</Button>
						<Button color="gray-o" size="md" onClick={() => saveCorp()}>다음</Button>
					</div>
				</main>
			</div>
		</PageContainer>
	);
}
export default ContentsContainer;